import { Vue, Component, toNative } from 'vue-facing-decorator';
import BulkDiscountTable from 'components/Discounts/BulkDiscount';
import { useRouter } from 'vue-router';
import Template from './template.vue';

@Component({
	components: {
		BulkDiscountTable,
	},
	mixins: [Template],
})

class BulkDiscount extends Vue {
	private router = useRouter();

	protected showModal(): void {
		this.$root?.$emit(
			'bv::show::modal',
			'bulkDiscount-modal',
			'#bulkDiscountShow',
		);
	}

	protected routeBulkDiscount(id: number): void {
		this.router.push(`/discount-bulk/${id}`);
	}
}

export default toNative(BulkDiscount);
